import * as R from "ramda";
import { call, takeLatest, put, select, take } from "redux-saga/effects";
import { replace } from "redux-little-router";
import {
  loadCollectionSuccess,
  loadCollectionFailed,
  loadMoreCollectionPostsSuccess,
} from "../../actions/collectionActions";
import * as CollectionApi from "../../api/CollectionApi";
import api from "../../api/api";
import { shouldWaitOnAuthDone } from "../../sagas/AuthSaga";

export function* handleLoadCollectionRequests({ collectionId, limit }) {
  const request = CollectionApi.getLoadCollectionUrl(collectionId, { limit });

  if (yield shouldWaitOnAuthDone()) {
    yield take("FIREBASE_AUTH_DONE");
  }
  try {
    const fullCollection = yield call(api.get, request.url, request.config);
    const collection = R.pick(["_id", "name", "owner", "gradientColor", "slug"], fullCollection.data.data);
    yield put(loadCollectionSuccess(collection));
    yield put(
      loadMoreCollectionPostsSuccess({
        posts: fullCollection.data.data.posts,
        limit,
        pagingToken: fullCollection.data.pagingToken,
        override: true,
      })
    );

    const currentUrlSlug = yield select(state => state.router.params.slug);
    if (collection.slug && collection.slug !== currentUrlSlug) {
      yield put(replace(`/collections/${collection._id}/${collection.slug}`));
    }
  } catch (error) {
    yield put(loadCollectionFailed({ data: error.response.data, status: error.response.status }));
  }
}

function* handleLoadMoreCollectionPostsRequests({ collectionId, pagingToken, limit }) {
  const request = CollectionApi.getLoadCollectionUrl(collectionId, { pagingToken, limit });

  try {
    const {
      data: {
        data: { posts },
        pagingToken,
      },
    } = yield call(api.get, request.url, request.config);
    yield put(
      loadMoreCollectionPostsSuccess({
        posts,
        limit,
        pagingToken,
      })
    );
  } catch (error) {
    console.log(error);
  }
}

export function* watchCollectionsRequests() {
  yield takeLatest("LOAD_COLLECTION_REQUEST", handleLoadCollectionRequests);
  yield takeLatest("LOAD_MORE_COLLECTION_POSTS_REQUEST", handleLoadMoreCollectionPostsRequests);
}



// WEBPACK FOOTER //
// ./src/scenes/CollectionPage/sagas.js